"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UndefinedContent = function UndefinedContent() {

  return _react2.default.createElement(
    "div",
    { className: "undefinedContent" },
    _react2.default.createElement("i", { className: "warning sign icon" }),
    " ",
    _react2.default.createElement(
      "span",
      null,
      "non presente"
    )
  );
};

exports.default = UndefinedContent;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/UndefinedContent.js
// module id = 107
// module chunks = 0